import React from "react";
import DatePicker from "react-datepicker";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import ru from "date-fns/locale/ru";
registerLocale("ru", ru);

export default class DtPicker extends React.Component {
  onChange = (v) => {
    this.props.onChange(v);
  };
  render() {
    let pickerExtProps = {};
    pickerExtProps.selected = this.props.value
      ? new Date(this.props.value)
      : "";
    pickerExtProps.dateFormat = "dd.MM.yyyy";

    if (this.props.time) {
      pickerExtProps.showTimeInput = true;
      pickerExtProps.timeInputLabel = "Время:";
      pickerExtProps.dateFormat = "Время:";
      pickerExtProps.dateFormat = "dd.MM.yyyy HH:mm";
    }

    const InlineDate = React.forwardRef(({ value, onClick }, ref) => (
      <span
        className="cursor-pointer text-hover-primary"
        onClick={onClick}
        ref={ref}
        style={{ whiteSpace: "nowrap" }}
      >
        {value}
      </span>
    ));

    return (
      <DatePicker
        onChange={this.onChange}
        className="form-control"
        locale="ru"
        isClearable={this.props.isClearable}
        customInput={this.props.inline && <InlineDate />}
        {...pickerExtProps}
      />
    );
  }
}
